import { render, staticRenderFns } from "./LeadNotifications.vue?vue&type=template&id=2dfa4b9e&"
import script from "./LeadNotifications.vue?vue&type=script&lang=js&"
export * from "./LeadNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports